/** *@name:index *@author:dingyongya *@date:2022/10/8 11:10 *@update:2022/10/8 11:10 */

<template>
  <el-tooltip v-if="tagType === 'text'" v-bind="$attrs" :disabled="disabled">
    <div ref="tooltipContent" class="tooltip-content" @mouseenter="init">
      <slot />
    </div>
  </el-tooltip>
  <el-tooltip v-else :disabled="disabled" :content="content" placement="top" popper-class="mg-tooltip" ref="mgTooltip">
    <div class="mg-tooltip-tag" @mouseenter="init">
      <slot />
    </div>
  </el-tooltip>
</template>

<script>
  export default {
    name: 'MgTooltip',
    props: {
      tagType: {
        type: String,
        default: 'text',
      },
      tag: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        disabled: true,
        content: '',
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        if (this.tagType === 'text') {
          const el = this.$refs.tooltipContent.firstChild

          if (el.scrollHeight > el.clientHeight) {
            this.disabled = false
          }
        } else {
          this.refreshInit()
        }
      },
      refreshInit() {
        this.$nextTick(() => {
          const childWidth = this.$refs.mgTooltip?.$el?.firstElementChild?.offsetWidth
          const elWidth = this.$refs.mgTooltip?.$el?.offsetWidth
          if (childWidth > elWidth) {
            this.disabled = false
          }
          if (['inputSearch', 'input', 'autocomplete'].includes(this.tag.type)) {
            this.content = `${this.tag.label}: ${this.tag.value}`
          } else if (['selectTree'].includes(this.tag.type)) {
            this.content = `${this.tag.label}: ${this.tag.value.map((item) => item.name).toString()}`
          } else if (['select'].includes(this.tag.type)) {
            this.content = `${this.tag.label}: ${this.tag.value.map((item) => item.label).toString()}`
          }
        })
      },
    },
  }
</script>

<style scoped lang="scss">
  .tooltip-content {
    // text-overflow: ellipsis;
    // overflow: hidden;
    // white-space: nowrap;
    cursor: pointer;
    height: 100%;
  }
  .mg-tooltip-tag {
    display: inline-block;
    max-width: 1100px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 18px;
  }
  ::v-deep(.mg-tooltip) {
    .el-tooltip__popper {
      max-width: 1100px;
    }
    .el-tag__close {
      margin-top: 2px;
    }
  }
</style>
